import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Logo from './Logo';
import {withRouter, Link} from 'react-router-dom';
class HeaderBar extends React.Component {

    constructor(props){
        super(props);

    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    render(){
        return (
            <div className="HeaderBar">
                <Link to="/"> <Logo /></Link>

                <button
                    onClick={()=>{this.props.history.goBack()}}
                >
                    <svg data-name="Layer 1" viewBox="0 0 50 50">
                        <g data-name="Group 11">
                            <g data-name="Ellipse 6">
                                <circle className="white-fill" cx={25} cy={25} r="23.76" fill="#fff" />
                                <circle
                                    cx={25}
                                    cy={25}
                                    r="22.76"
                                    fill="none"
                                    stroke="#2699fb"
                                    strokeWidth={2}
                                />
                            </g>
                            <g data-name="Backward arrow">
                                <path
                                    data-name="Path 10"
                                    d="M25.24 33.24l1.45-1.46-5.51-5.51h12.06V24.2H21.19l5.51-5.5-1.45-1.45-8 8z"
                                    fill="#2699fb"
                                />
                            </g>
                        </g>
                    </svg>

                </button>
            </div>
        )
    }
}

HeaderBar.propTypes = {
    
}

const mapStateProps = (state) => {
    return {
    
    };
}

export default  connect(mapStateProps, {  })(withRouter(HeaderBar));



// WEBPACK FOOTER //
// ./src/components/common/HeaderBar.js